// for add employee state
export const TABLE_FILTER_SELECTED_OPTIONS = "table_filter_selected_options";
